import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

const MoloniDocument = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isApp = Number(localStorage.getItem("isApp"));

  const data = [
    { id: 1, name: "documents", label: "Documents", icon: "bi-folder" },
    { id: 2, name: "invoice", label: "Invoice", icon: "bi-receipt" },
    { id: 3, name: "receipts", label: "Receipts", icon: "bi-cash-stack" },
    {
      id: 4,
      name: "creditNotes",
      label: "Credit Notes",
      icon: "bi-file-earmark-plus",
    },
    {
      id: 5,
      name: "debitNotes",
      label: "Debit Notes",
      icon: "bi-file-earmark-minus",
    },
    {
      id: 6,
      name: "simplifiedInvoices",
      label: "Simplified Invoices",
      icon: "bi-file-earmark-text",
    },
    { id: 7, name: "deliveryNotes", label: "Delivery Notes", icon: "bi-truck" },
    {
      id: 8,
      name: "billsOfLading",
      label: "Bills of Lading",
      icon: "bi-box-seam",
    },
    {
      id: 9,
      name: "ownAssetsMovement",
      label: "Own Assets Movement",
      icon: "bi-arrow-left-right",
    },
    { id: 10, name: "waybills", label: "Waybills", icon: "bi-truck-flatbed" },
    {
      id: 11,
      name: "customerReturnNotes",
      label: "Customer Return Notes",
      icon: "bi-arrow-counterclockwise",
    },
    { id: 12, name: "estimates", label: "Estimates", icon: "bi-calculator" },
    {
      id: 13,
      name: "internalDocuments",
      label: "Internal Documents",
      icon: "bi-journal-text",
    },
    {
      id: 14,
      name: "invoiceReceipts",
      label: "Invoice Receipts",
      icon: "bi-journal-check",
    },
    {
      id: 15,
      name: "paymentReturns",
      label: "Payment Returns",
      icon: "bi-arrow-repeat",
    },
    { id: 16, name: "purchaseOrder", label: "Purchase Order", icon: "bi-cart" },
    {
      id: 17,
      name: "supplierPurchaseOrder",
      label: "Supplier Purchase Order",
      icon: "bi-cart-check",
    },
    {
      id: 18,
      name: "supplierInvoices",
      label: "Supplier Invoices",
      icon: "bi-journal",
    },
    {
      id: 19,
      name: "supplierSimplifiedInvoices",
      label: "Supplier Simplified Invoices",
      icon: "bi-journal-text",
    },
    {
      id: 20,
      name: "supplierCreditNotes",
      label: "Supplier Credit Notes",
      icon: "bi-journal-plus",
    },
    {
      id: 21,
      name: "supplierDebitNotes",
      label: "Supplier Debit Notes",
      icon: "bi-journal-minus",
    },
    {
      id: 22,
      name: "supplierReturnNotes",
      label: "Supplier Return Notes",
      icon: "bi-box-arrow-in-left",
    },
    {
      id: 23,
      name: "supplierReceipts",
      label: "Supplier Receipts",
      icon: "bi-journal-check",
    },
    {
      id: 24,
      name: "supplierWarrantyRequests",
      label: "Supplier Warranty Requests",
      icon: "bi-tools",
    },
    { id: 25, name: "globalGuides", label: "Global Guides", icon: "bi-globe" },
  ];

  return (
    <div>
      <section className="content-header content-header-custom">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6 d-flex align-items-center">
              <button
                type="button"
                className="next-button btn btn-secondary"
                onClick={() => navigate("/moloni")}
              >
                <i className="bi bi-arrow-left"></i> {t("back")}
              </button>
            </div>

            <div className="col-sm-6 text-end">
              <h1
                className="page-title"
                // style={{
                //   marginTop: !isApp ? "0" : "-28px",
                // }}
              >
                {t("invoice")}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid container-custom-height-new">
          <div className="card bg-transparent shadow-none">
            <ul className="list-group list-group-custom">
              {data.map((item) => (
                <li key={item.id} className="list-group-item">
                  <Link
                    className="d-flex align-items-center"
                    to={`/${item.name}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <i className={`icon-moloni bi ${item.icon} me-2`}></i>
                    {t(item.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MoloniDocument;
